// extracted by mini-css-extract-plugin
module.exports = {"pageContainer":"CourseInformation_pageContainer_118AG","registrationCloseDate":"CourseInformation_registrationCloseDate_1CEnl"};